import script from "./PreviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewPage.vue?vue&type=script&setup=true&lang=js"

import "./PreviewPage.vue?vue&type=style&index=0&id=d64816a6&scoped=true&lang=css"
import "./PreviewPage.vue?vue&type=style&index=1&id=d64816a6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d64816a6"]])

export default __exports__